import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withLogger } from 'modules/shell/hoc/withLogger';
import withFeatureToggles from 'modules/shell/hoc/withFeatureToggles';

import { setRecentSearch, getRecentSearches } from 'utils';

import { DCL_MATCH_DATE, MY_CLIENTS_NMVIP_GROUP } from 'constants/featureToggleNames';
import ClientsInfiniteScrollList from './ClientInfiniteScrollList';
import styles from './ClientInfiniteScrollList.styles';

import { clearClientsCache, clearSingleClientCache } from '../../modules/clients/actions';

const mapStateToProps = ({ clientsModule, user }) => ({
  clientsStats: clientsModule.clientsList.stats,
  recentSearchList: getRecentSearches(),
  setRecentSearch,
  loading: clientsModule.clientsList.infiniteListLoading,
  customerFilterParams: clientsModule.clientsList.customerFilterParams,
  clients: clientsModule.clientsList.clients,
  userBrand: user?.data?.brand,
});

const mapDispatchToProps = {
  clearClientsCache,
  clearSingleClientCache,
};

export default compose(
  withStyles(styles),
  withFeatureToggles({
    isDclDateMatchEnabled: DCL_MATCH_DATE,
    isNMVipGroupEnable: MY_CLIENTS_NMVIP_GROUP,
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withLogger(),
)(ClientsInfiniteScrollList);
